export default __webpack_public_path__ + "static/media/rounded_pin_icon.3dcf4e81.svg";